<template>
  <div class="content-item-content">
    <div
      class="main"
      v-show="i < 4"
      v-for="(item, i) in recommends"
      :key="item.id"
      @click="handleView(item)"
    >
      <img class="cover" :src="item.cover" alt="" />
      <div class="main-info">
        <p>{{ item.title }}</p>
        <div class="main-info-item">
          <div class="name">
            <img :src="item.photo || serverURL + 'images/head.webp'" alt="" />
            {{ item.name }}
          </div>
          <div class="view"><i class="el-icon-view"></i> {{ item.view }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { architectures } from '@/api/index'
import { viewProduction } from '@/api/personalCenter/index'
export default {
  name: 'recommend',
  components: {},
  props: [],
  data() {
    return {
      recommends: []
    }
  },
  watch: {},
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    }
  },
  created() {
    this.getRecommends()
  },
  mounted() {},
  methods: {
    getRecommends() {
      const recommends = []
      architectures().then((res) => {
        const { data } = res.data.models
        data.forEach(v => {
          recommends.push({
            id: v.id,
            cover: v.cover,
            title: v.title,
            photo: v.user.userLogo,
            name: v.user.userNickName,
            view: v.view_count,
            path: v.show,
          })
        });
        this.recommends = recommends
      })
    },
    async handleView(val) {
      await viewProduction(val.id).then(res => {
        console.log(res);
      }).catch(err =>{
        console.log(err);
      })
      let url = decodeURIComponent(val.path)
      window.location.href = url
    },
  },
}
</script>

<style lang="scss" scoped>
.content-item-content {
  width: 100%;
  display: flex;
  .main {
    width: 25%;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    margin-top: 20px;
    color: #666666;
    background: #ffffff;
    box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
    border-radius: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    .cover {
      width: 100%;
      height: 12rem;
      border-radius: 10px 10px 0px 0px;
    }
    &-info {
      padding: 10px;
      p {
        min-height: 2.8rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      &-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999999;
        .name {
          display: flex;
          align-items: center;
          img {
            width: 23px;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>